<template>
    <div class="flex flex-row my-2">
        <div class="grow pr-2">
            <input
                id="drop-and-paste-zone"
                class="hidden transition-all"
                accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                autocomplete="off"
            >
            <label
                for="drop-and-paste-zone"
                class="p-2 cursor-pointer border border-base-300 border-dashed hover:border-gray-500 transition-all rounded text-center flex items-center"
                :class="file ? 'flex-row': 'flex-col'"
                @dragover.prevent
                @drop.prevent="onDrop"
                @paste="(e) => emit('onPasted', e)"
            >
                <span class="flex flex-col items-center w-full">
                    <span class="flex items-center h-full py-4">
                        <span class="text-sm">Lim inn fra Excel, dra og slipp eller</span>
                        <input
                            id="attachment-file-upload"
                            type="file"
                            class="hidden transition-all"
                            accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            autocomplete="off"
                            @change="uploadFileWithFilePicker"
                        >
                        <label for="attachment-file-upload" class="btn btn-sm btn-outline ml-2" @click="uploadFileWithFilePicker">Last opp fil<i class="i-ph-upload"/></label>
                    </span>

                    <span v-if="file" class="flex items-center mb-2">
                        <i class="mr-1" :class="resolveFileIcon(file.name)"/>
                        <span class="">{{ file.name }}</span>
                        <i class="i-mdi-close text-error hover:text-red-500 pointer-cursor" @click.stop.prevent="removeFile"/>
                    </span>
                </span>
            </label>
        </div>
    </div>
</template>

<script setup lang="ts">

import { ref } from 'vue'
import { resolveFileIcon } from '@/services/document.service'

const file = ref()
const emit = defineEmits(['onDrop', 'onUpload', 'onPasted', 'clearGrid'])

const onDrop = (e: Event) => {
    emit('onDrop', e)
    const target = e.target as HTMLInputElement
    if (target.files && target.files.length > 0) file.value = target.files[0]
}

const uploadFileWithFilePicker = (e: Event) => {
    const target = e.target as HTMLInputElement
    if (target.files && target.files.length > 0) {
        file.value = target.files[0]
        emit('onUpload', file.value)
    }
}

const removeFile = () => {
    file.value = null
    emit('clearGrid')
}

</script>

<style lang="scss" scoped>

</style>